import { InstitutionalLayout } from '@/components/site/InstitutionalLayout';
import { legalRoutes } from '@/content/company';
import { checkoutPath } from '@/content/plans';
import { DataDeletionPage } from '@/pages/DataDeletionPage';
import { PrivacyPolicyPage } from '@/pages/PrivacyPolicyPage';
import { TermsOfUsePage } from '@/pages/TermsOfUsePage';
import { HomePageSite } from '@/pages/site/HomePageSite';
import { ClientesPage } from '@/pages/site/ClientesPage';
import { ProdutoPage } from '@/pages/site/ProdutoPage';
import { AppsPage } from '@/pages/site/AppsPage';
import { SetoresPage } from '@/pages/site/SetoresPage';
import { PrecosPage } from '@/pages/site/PrecosPage';
import { CalculadoraPage } from '@/pages/site/CalculadoraPage';
import { SobrePage } from '@/pages/site/SobrePage';
import { ContatoPage } from '@/pages/site/ContatoPage';
import { AppDetailPage } from '@/pages/site/seo/AppDetailPage';
import { CasePage } from '@/pages/site/seo/CasePage';
import { GuidePage } from '@/pages/site/seo/GuidePage';
import { GuidesIndexPage } from '@/pages/site/seo/GuidesIndexPage';
import { NotFoundPage } from '@/pages/site/seo/NotFoundPage';
import { SectorPage } from '@/pages/site/seo/SectorPage';
import { lazy, Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';

/*
 * Checkout, orçamento e cadastro sob consulta carregam sob demanda. São páginas
 * de transação: nunca entram no HTML gerado no build e não precisam pesar no
 * JavaScript de quem só está lendo o site.
 */
const CheckoutPage = lazy(() => import('@/pages/CheckoutPage').then((m) => ({ default: m.CheckoutPage })));
const QuoteDealPage = lazy(() => import('@/pages/QuoteDealPage').then((m) => ({ default: m.QuoteDealPage })));
const OndemandSignupPage = lazy(() =>
  import('@/pages/OndemandSignupPage').then((m) => ({ default: m.OndemandSignupPage })),
);

function Carregando() {
  return <div style={{ minHeight: '60vh' }} aria-busy="true" />;
}

export function App() {
  return (
    <Routes>
      <Route element={<InstitutionalLayout />}>
        <Route index element={<HomePageSite />} />
        <Route path="/produto" element={<ProdutoPage />} />
        <Route path="/apps" element={<AppsPage />} />
        <Route path="/apps/:slug" element={<AppDetailPage />} />
        <Route path="/setores" element={<SetoresPage />} />
        <Route path="/setores/:slug" element={<SectorPage />} />
        <Route path="/guias" element={<GuidesIndexPage />} />
        <Route path="/guias/:slug" element={<GuidePage />} />
        <Route path="/clientes" element={<ClientesPage />} />
        <Route path="/casos/:slug" element={<CasePage />} />
        <Route path="/precos" element={<PrecosPage />} />
        <Route path="/calculadora" element={<CalculadoraPage />} />
        <Route path="/sobre" element={<SobrePage />} />
        <Route path={legalRoutes.contact} element={<ContatoPage />} />
        <Route path={legalRoutes.privacy} element={<PrivacyPolicyPage />} />
        <Route path={legalRoutes.terms} element={<TermsOfUsePage />} />
        <Route path={legalRoutes.dataDeletion} element={<DataDeletionPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>

      <Route
        path={checkoutPath}
        element={
          <Suspense fallback={<Carregando />}>
            <CheckoutPage />
          </Suspense>
        }
      />
      <Route
        path="/orcamento/:token"
        element={
          <Suspense fallback={<Carregando />}>
            <QuoteDealPage />
          </Suspense>
        }
      />
      <Route
        path="/solicitar-orcamento"
        element={
          <Suspense fallback={<Carregando />}>
            <OndemandSignupPage />
          </Suspense>
        }
      />
    </Routes>
  );
}
